import { render } from "./AddModeLivraisonModal.vue?vue&type=template&id=321964f2&ts=true"
import script from "./AddModeLivraisonModal.vue?vue&type=script&lang=ts"
export * from "./AddModeLivraisonModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__